import * as React from "react";
import { CuriositiesProps } from "./types";
import { Accordion } from "react-accessible-accordion";
import Curiosity from "./curiosity";

export const Curiosities: React.FC<CuriositiesProps> = ({
  item,
  showCount,
}: CuriositiesProps) => {
  const showAmount = showCount ?? item.curiosities.length;
  return (
    <Accordion allowZeroExpanded={true}>
      {item.curiosities.slice(0, showAmount).map((curiosity, i) => (
        <Curiosity key={i} item={curiosity} />
      ))}
    </Accordion>
  );
};
